import { ArrayReduceFn, DictionaryReduceFn, dictionaryToArray } from './internal'

/**
 * Simple array reduce (wraps native Array#reduce)
 */
export function _reduce<T, R>(collection: T[], reducer: ArrayReduceFn<T, R>, initial: R): R;

/**
 *  Simple object reduce (takes each Key-Value from the given object and reduces based on the value)
 */
export function _reduce<T extends object, R>(collection: T, reducer: DictionaryReduceFn<T, R>, initial: R): R;

/**
 * Null | undefined collection will return initial value.
 */
export function _reduce<T, R>(collection: null | undefined, reducer: any, initial: R): R;

/**
 * Override implementation.
 */
export function _reduce<T, R>(collection: any, reducer: any, initial: R): R {
	if (!collection || !reducer || typeof collection !== 'object') return initial

	if (Array.isArray(collection)) {
		return collection.reduce(reducer, initial)
	}

	const list = dictionaryToArray(collection)

	// Performance hit here for wrapping the predicate fn in another anonymous function - we need to pass key.
	return list.reduce((a, c) => reducer(a, c.value, c.key, collection), initial)
}